import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import KEYCODE from 'keycode'
import { get } from 'lodash'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import { parseLocation } from '../../../common/utils/urlHelper'
import filtersParamsConfig from '../../../common/constants/filterParamsConfig'
import FiltersMultiSelectPanel from './filtersPanel/multiSelect'
import DocumentIcon from '../icons/document'

class FiltersFileType extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  render() {
    const { showPanel } = this.state
    const { items, location } = this.props
    const parsedLocation = parseLocation(location)
    const formattedItems = items.map(item =>
      Object.assign({}, item, {
        label: get(filtersParamsConfig, `file_formats.labels.${item.key}`)
      })
    )

    const chosenFileType = parsedLocation.file_formats || ''

    const renderChosenOptions = () => {
      if (chosenFileType === '') {
        return (
          <ul className="search-facet-listing">
            {formattedItems.map((item, index) => {
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">
                      {item.label}
                    </span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        return (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              <div className="search-facet-panel__status-title">
                {chosenFileType.split(',').join(', ')}
              </div>
            </div>
          </div>
        )
      }
    }

    const { isAtTop } = this.props
    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--one-facet': isAtTop,
      'search-facet-panel__header--end': !isAtTop,
      'is-active': showPanel
    })

    return (
      <div className="search-facet--no-margin" id="file-type-filter">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <DocumentIcon /> File type
          </h2>
          {renderChosenOptions()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersMultiSelectPanel
                type="file_formats"
                showPanel={showPanel}
                items={formattedItems}
                parsedLocation={parsedLocation}
                togglePanel={this.togglePanel}
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersFileType.propTypes = {
  items: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
}

export default FiltersFileType



// WEBPACK FOOTER //
// ./client/components/filters/filtersFileType.js